
<navbar />
<div class="dashboard-container">
  <div class="company-second-card rounded-lg shadow p-5 border">
    <!-- Company First Card with side margins -->
    <div class="company-first-card mb-4 shadow-lg rounded-lg w-100 px-3 py-2 position-relative" :class="{
    'bolide-bg': hostname.includes('bolide.complyon'),
    'ndabeni-bg': hostname.includes('ndabenitrust.complyon'),
    'x-verdict-bg': hostname.includes('x-verdict'),
    'complyon-bg': hostname.includes('business.complyon') || hostname.includes('complyon.ai') || hostname.includes('aicampus.complyon') ,
    'probaworkflows-bg': hostname.includes('probaworkflows'),
    'trustfirst-bg':hostname.includes('trustfirst.probaanalytics'),
    'rematholdings-bg':hostname.includes('rematholdings.complyon'),
    'dwypd-bg':hostname.includes('monitoring.dwypd.gov')
     }">
      <section class="hero-section w-100 px-2 py-1 d-flex justify-content-between align-items-start">

        <!-- Hero content on left -->
        <div class="hero-content p-1 me-5 col-md-7 col-lg-6">
          <h1 class="hero-title text-white text-x fw-bold">{{ hero_title }}</h1>
          <p class="hero-description mt-1 text-white text-xs">
           {{ hero_description }}
          </p>
        </div>
        <div class="d-none d-md-block position-absolute mt-5 img-styles">
          <img
            src="@/assets/images/trustfirst/pictures/trustfirst_image.png"
            alt="Hero Image"
            class="d-none img-size-styles"
          />
        </div>
      </section>
      <div class="d-flex gap-2 justify-content-end">
            <button class="btn btn-primary-dark btn-sm text-xxs mt-3 text-dark" data-bs-toggle="modal" data-bs-target="#create_company">
            Create Client
          </button>
          <button class="btn btn-primary-dark btn-sm text-xxs mt-3 text-dark" data-bs-toggle="modal" data-bs-target="#activate_projects">
            Deactivated clients
          </button>
          <button
                v-if="$route.name === 'configure_company_management' && is_super_user === true"
                @click="redirect_to_config()"
                class="btn btn-primary-dark btn-sm text-xxs mt-3 text-dark">
            Configure Platform
          </button>
          </div>
    </div>
    <div>
      <div>
        <div>
          <GlobalTable

            :headers="table_headers"
            :data="table_safe_company_list"
            table_id="company_management_table">
            <template #actions="{ row }">
              <button @click="redirect_to_overview(row.id, row.Client)"
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark d-none">
                View
              </button>
              <button
                @click="redirect_to_config(row.id, row.Client)"
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark">
                Configure
              </button>
              <button
                @click="select_project(row.id)"
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                data-bs-toggle="modal" data-bs-target="#assign_users">
                Assign
              </button>
              <button
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                data-bs-toggle="modal" data-bs-target="#update_company"
                @click="prepopulate_update_company_modal(row.id)">
                Edit
              </button>
              <button
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                @click="deactivate_company(row.id)">
                Deactivate
              </button>
            </template>
          </GlobalTable>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <AICampusFooter/>
</div>


<!-- Create Company Modal -->
<teleport to="body">
<div class="modal fade" id="create_company" tabindex="-1" aria-labelledby="create_section_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="create_project_label">
         Create Client
        </p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label for="company_name" class="modal-form-label form-label text-xxs">
            Client Name:
          </label>
          <input type="text" v-model="company_name" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
            placeholder="Enter Client Name Here" />
          <small class="text-danger p-2 text-xxs fw-bold d-none project-name-messages">Please enter a name for the
            company</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="company_description" class="modal-form-label form-label text-xxs">
            Client Description:
          </label>
          <input type="text" v-model="company_description"
            class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-xxs"
            placeholder="Enter Client Description Here" />
          <small class="text-danger p-2 text-xxs fw-bold d-none project-description-messages">Please enter a description
            for the company</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="company_type" class="modal-form-label form-label text-xxs">
            Client Type:
          </label>
          <select v-model="selected_company_type" class="modal-form-select form-select text-xxs rounded-small p-2 shadow-sm text-x">
            <option value="" disabled hidden>Select Type</option>
            <option v-for="type in company_types" :key="type.id" :value="type.id">
              {{ type.project_type }}
            </option>
          </select>
          <small class="text-danger p-2 text-xxs fw-bold d-none project-type-messages">Please select a client
            type</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="create_company">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Assign Users Modal -->
<teleport to="body">
<div class="modal fade" id="assign_users" tabindex="-1" aria-labelledby="assign_users_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="assign_users_label">Assign Users</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <GlobalTable
          v-if="users_list.length > 0"
          :headers="user_table_headers"
          :data="users_list"
          :key="users_list"
          table_id="user_assignment_table"
        >
          <template #actions="{ row }">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                :id="'switch_' + row.user_id"
                :checked="assigned_users.includes(row.user_id)"
                @change="toggle_assignment(row.user_id)"
              >
              <label class="form-check-label" :for="'switch_' + row.user_id">
                {{ assigned_users.includes(row.user_id) ? 'Assigned' : 'Unassigned' }}
              </label>
            </div>
          </template>
        </GlobalTable>
      </div>
    </div>
  </div>
</div>
</teleport>


<!-- Activate projects Modal -->
<teleport to="body">
<div class="modal fade" id="activate_projects" tabindex="-1" aria-labelledby="activate_projects_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="activate_projects_label">Activate Client</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
         <div class="card shadow-sm border table-border-color rounded-lg p-3 table-responsive text-xs">
            <table id="deactivated_projects_table" class="table table-hover">
                <thead class="custom-header">
                  <tr>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">ID</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Client</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Description</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Type</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Assigned Administrator</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="project in deactivated_projects" :key="project.id">
                    <td class="text-xxs text-start">{{ project.id }}</td>
                    <td class="text-xxs text-start">{{ project.name }}</td>
                    <td class="text-xxs text-start">{{ project.project_description }}</td>
                    <td class="text-xxs text-start">{{ project.project_type?.name || '-' }}</td>
                    <td class="text-xxs text-start">{{ project.creator?.full_name || '-' }}</td>
                    <td class="text-xxs text-start">
                      <button class="btn btn-primary-dark btn-sm rounded shadow me-2 text-xxs" @click="activate_projects(project.id)">Activate</button>
                    </td>
                  </tr>
                </tbody>
            </table>
          </div>
      </div>
    </div>
  </div>
</div>
</teleport>


<!-- Update Company Modal -->
<teleport to="body">
<div class="modal fade" id="update_company" tabindex="-1" aria-labelledby="update_company_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="update_company_label">
         Update Client
        </p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <div class="modal-form-group form-group mb-3">
          <label for="update_company_name" class="modal-form-label form-label text-xxs">
            Client Name:
          </label>
          <input type="text" v-model="update_company_name" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" />
          <small class="text-danger p-2 text-xxs fw-bold d-none update-company-name-messages">Please enter a name for the
            company</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>

        <div class="modal-form-group form-group mb-3">
          <label for="update_company_description" class="modal-form-label form-label text-xxs">
            Client Description:
          </label>
          <input type="text" v-model="update_company_description"
            class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-xxs"/>
          <small class="text-danger p-2 text-xxs fw-bold d-none update-company-description-messages">Please enter a description
            for the company</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>

        <div class="modal-form-group form-group mb-3">
          <label for="update_company_type" class="modal-form-label form-label text-xxs">
            Client Type:
          </label>
          <select v-model="update_selected_company_type" class="modal-form-select form-select text-xxs rounded-small p-2 shadow-sm text-x">
            <option value="" disabled hidden>Select Type</option>
            <option v-for="type in company_types" :key="type.id" :value="type.id">
              {{ type.project_type }}
            </option>
          </select>
          <small class="text-danger p-2 text-xxs fw-bold d-none update-company-type-messages">Please select a client
            type</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>

      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="update_project">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

